



















import { Component, Vue } from "vue-property-decorator";
import { templateApi } from "../api";
import {
  saveProject,
  saveEndUserProject,
  getDefaultIcon
} from "@/api/project-api";
import { getAllClients, getAllClientStaffs, Client } from "@/api/client-api";
import { Staff } from "@/api/company-api";
import { Company, Office } from "@/api/company-api";
import ProjectFormData from "@/api/models/ProjectFormData";
import ProjectFormEndUserData from "@/api/models/ProjectFormEndUserData";
import createProjectOutput from "@/api/models/factories/createProjectOutput";
import createOrderOutput from "@/api/models/factories/createOrderOutput";

import AppHeader from "@/views/AppHeader.vue";
import ProjectEdit from "@/templates/ProjectEdit.vue";
import ProjectTemplate from "../models/project-template";
import UploadFileSpec from "../models/specs/UploadFileSpec";
import SelectOption from "@/common/ui/presenters/select-option";
import createCompany from "@/helpers/createCompany";

@Component({
  components: {
    AppHeader,
    ProjectEdit
  }
})
export default class ProjectNewPage extends Vue {
  project = createProjectOutput();
  order = createOrderOutput();
  company: Company | null = null;
  office: Office | null = null;

  get clientOptions(): SelectOption[] {
    return this.clientList.map(c => new SelectOption(c, "id", "name"));
  }

  get clientStaffOptions(): SelectOption[] {
    return this.filteredClientStaffList.map(
      s => new SelectOption(s, "staffId", "name")
    );
  }

  get templateOptions(): SelectOption[] {
    return this.templateList.map(t => new SelectOption(t, "id", "title"));
  }

  async ok() {
    try {
      await this.save();
      this.goListPage();
    } catch (e) {
      console.error(e);
      alert("エラーのため送信できませんでした。");
    }
  }

  cancel() {
    this.goListPage();
  }

  updateIcon(e: Event) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    const url = URL.createObjectURL(files[0]);
    this.project.icon = url;
    this.project.iconFile = files[0];
  }

  private clientList: Client[] = [];
  private clientStaffList: Staff[] = [];
  private templateList: ProjectTemplate[] = [];

  private get filteredClientStaffList(): Staff[] {
    const cid = this.order.clientId;
    if (!cid) return this.clientStaffList;
    return this.clientStaffList.filter(s => cid === String(s.officeId));
  }

  public created() {
    [this.company, this.office] = createCompany();
    this.initIcon();
    this.initClientList();
    this.initClientStaffList();
    this.initTemplateList();
  }

  private async initIcon() {
    this.project.icon = await getDefaultIcon();
  }

  private async initClientList() {
    this.clientList = await getAllClients();
  }

  private async initClientStaffList() {
    this.clientStaffList = await getAllClientStaffs();
  }

  private async initTemplateList() {
    this.templateList = await templateApi.getAll();
  }

  private async save() {
    if (!this.company || !this.office) return;
    if (!this.order.endUser) {
      const d = ProjectFormData(this.project, this.order);
      await saveProject(d);
      await this.$store.dispatch("updateProjects");
    } else {
      const d = ProjectFormEndUserData(
        this.project,
        this.order,
        this.company,
        this.office
      );
      await saveEndUserProject(d);
      await this.$store.dispatch("updateProjects");
    }
  }

  private goListPage() {
    this.$router.push({ name: "project-list" });
  }
}
